var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticClass:"intercom-button",on:{"click":_vm.toggleIntercom}},[_c('v-list-item-icon',[_c('icon-base',{attrs:{"icon":"sidebar/support"}})],1),_c('v-list-item-title',{staticClass:"pr-2"},[_vm._v(" Talk to Support "),_c('v-fade-transition',[_c('notifications-count-badge',{attrs:{"count":_vm.unreadCount}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }